// 统一请求路径前缀在libs/axios.js中修改
import {get, post, commonL} from '@/network/db';

//统计未处理投诉总数
export const statisticalGetComplaintCount = () => {
    return post('/manager/statistical/getComplaintCount')
}

//统计待审陪诊人
export const statisticalGetAttendantCount = () => {
    return post('/manager/statistical/getAttendantCount')
}

//分页获取待处理投诉
export const complaintList = (params) => {
    return post('/manager/complaint/list', params, false, true)
}

//查看待处理投诉详情
export const complaintDetails = (params) => {
    return post('/manager/complaint/details', params,false, true)
}

//查看投诉相关附件
export const complaintShow = (params) => {
    return post('/manager/complaint/show', params,false, true)
}

//处理投诉
export const complaintUpdate = (params) => {
    return post('/manager/complaint/update', params,false, true)
}

//分页获取陪诊人
export  const attendantList = (params) => {
    return get('/manager/attendant/list', params)
}

//查看陪诊人详情
export  const attendantDetail = (id) => {
    return get('/manager/attendant/detail/' + id)
}

//审核陪诊人详情
export  const attendantAudit = (params) => {
    return post('/manager/attendant/audit', params, false, true)
}

//发送短信验证码
export  const sendSms = (params) => {
    return commonL('/common/common/sms/'+params.type+'/'+params.phone, params.data, false, true)
}

//分页获取订单列表
export const orderList = (params) => {
    return get('/manager/order/page', params)
}

//查看订单详情
export const orderDetail = (id) => {
    return get('/manager/order/detail/' + id)
}